import { combineReducers } from 'redux';
import {
  logout_user_reducer,
  get_user_reducer,

  //candidate profile
  fetch_candidate_profile_reducer,
  update_candidate_profile_reducer,
  fetch_candidate_public_profile_reducer,

  //master
  fetch_headlines_reducer,
  fetch_skills_reducer,
  fetch_pronouns_reducer,
  fetch_colleges_reducer,
  fetch_cities_reducer,
  fetch_regions_reducer,
  fetch_countries_reducer,
  fetch_companies_reducer,
  fetch_courses_reducer,
  fetch_course_types_reducer,
  fetch_user_contacts_reducer,
  fetch_user_contact_details_reducer,
  fetch_user_company_bookmarks_reducer,
  fetch_user_company_details_bookmark_reducer,
  fetch_all_admin_contacts_reducer,

  // organisation
  get_organisation_users_reducer,
  get_organisation_reducer,

  //category
  fetch_categories_reducer,

  // microsoft
  check_microsoft_auth_reducer,
  fetch_microsoft_email_threads_reducer,
} from './reducer';

const rootReducer = combineReducers({
  logout_user_reducer,
  get_user_reducer,

  fetch_candidate_profile_reducer,
  update_candidate_profile_reducer,
  fetch_candidate_public_profile_reducer,

  //master
  fetch_headlines_reducer,
  fetch_skills_reducer,
  fetch_pronouns_reducer,
  fetch_colleges_reducer,
  fetch_cities_reducer,
  fetch_regions_reducer,
  fetch_countries_reducer,
  fetch_companies_reducer,
  fetch_courses_reducer,
  fetch_course_types_reducer,

  fetch_user_contacts_reducer,
  fetch_user_contact_details_reducer,

  fetch_user_company_bookmarks_reducer,
  fetch_user_company_details_bookmark_reducer,

  fetch_all_admin_contacts_reducer,

  // organisation
  get_organisation_users_reducer,
  get_organisation_reducer,

  //category
  fetch_categories_reducer,

  // microsoft
  check_microsoft_auth_reducer,
  fetch_microsoft_email_threads_reducer,
});

export default rootReducer;
